export const COST_CENTERS_TABLE_KEY = 'v1/cost-centers';
export const COST_CENTERS_TABLE_SETTINGS = 'cost_centers';
export const COST_CENTERS_QUERY_KEY = 'costCenters';
export const COST_CENTERS_NAME_KEY = 'name';
export const COST_CENTERS_CUSTOMER_KEY = 'customer';
export const COST_CENTERS_NOTE_KEY = 'note';
export const COST_CENTERS_CREATED_BY_KEY = 'createdBy';
export const COST_CENTERS_CREATED_AT_KEY = 'createdAt';
export const COST_CENTERS_MODIFIED_BY_KEY = 'modifiedBy';
export const COST_CENTERS_MODIFIED_AT_KEY = 'modifiedAt';
export const COST_CENTERS_DETAIL_KEY = 'detail';
export const COST_CENTERS_DELETE_KEY = 'delete';
